<script>
    import API from '../api';
    import Pagination from "./Pagination.svelte";
    import TreeNode from "./TreeNode.svelte";

    export let root = {
        id: '021736',
        text: 'Nodo radice',
        tags: [],
        children: {},
    };

    async function goToPage(e) {
        root.children = await API.childrens(id, e.detail.page);
    }
</script>

<div class="container tree">
    <div class="card bg-secondary">
        <div class="card-header ">
            <h1>{@html root.text}</h1>
        </div>

        <ul class="list-group list-group-flush">
            {#each root.children.elements as child (child.id)}
                <TreeNode {...child} />
            {/each}
        </ul>

        {#if root.children.num_pages > 1}
            <div class="card-footer">
                <Pagination on:page-change={goToPage} current={root.children.current_page} total={root.children.num_pages} />
            </div>
        {/if}
    </div>
</div>

<style>
    .card-header, .card-footer {
        background-color: #EF4136;
    }

    .card-header h1 {
        color: white;
    }
</style>